var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFfSort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83053 3.34864V12.1667C3.83053 12.6269 4.20362 13 4.66386 13C5.1241 13 5.49719 12.6269 5.49719 12.1667V3.34172L7.82806 5.67259C8.1535 5.99803 8.68114 5.99803 9.00657 5.67259C9.33201 5.34715 9.33201 4.81951 9.00657 4.49408L5.25657 0.744078C5.09342 0.58092 4.87944 0.499562 4.66559 0.500002C4.66501 0.500001 4.66444 0.5 4.66386 0.5C4.41071 0.5 4.18392 0.612881 4.03109 0.791054L0.328062 4.49408C0.00262513 4.81951 0.00262513 5.34715 0.328062 5.67259C0.653499 5.99803 1.18114 5.99803 1.50657 5.67259L3.83053 3.34864ZM11.7472 3C12.2074 3 12.5805 3.3731 12.5805 3.83333V12.6583L14.9114 10.3274C15.2368 10.002 15.7645 10.002 16.0899 10.3274C16.4153 10.6528 16.4153 11.1805 16.0899 11.5059L12.3399 15.2559C12.1767 15.4191 11.9627 15.5005 11.7488 15.5C11.7483 15.5 11.7477 15.5 11.7472 15.5C11.494 15.5 11.2673 15.3871 11.1144 15.2089L7.4114 11.5059C7.08596 11.1805 7.08596 10.6528 7.4114 10.3274C7.73683 10.002 8.26447 10.002 8.58991 10.3274L10.9139 12.6514V3.83333C10.9139 3.3731 11.287 3 11.7472 3Z",
    fill: "#101E3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfSort);
export default __webpack_public_path__ + "static/media/ff-sort.0d369a4f28e0d249d0c124893630653e.svg";
export { ForwardRef as ReactComponent };